import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../WorkoutTemplateBuilder'

export default function PhaseNoteInputBox({ phase, phaseIndex }) {
    const { mode, mutatePhase } = useContext(WorkoutTemplateBuilderContext)

    switch (mode) {
        // Edit mode
        case 'edit':
            return (
                <textarea
                    type="text"
                    name="phaseNote"
                    id="phaseNote"
                    className="h-8 block text-xs w-full px-2 py-2 resize-y border-t border-stone-400 rounded-b-lg"
                    placeholder={'Phase Note..'}
                    value={phase.note}
                    onChange={(event) => mutatePhase('change-phase-note', phaseIndex, event.target.value)}
                    disabled={false}
                />
            )

        // View mode
        case 'view':
            // If the phase note is not empty
            if (phase.note !== '') {
                return (
                    <textarea
                        type="text"
                        name="phaseNote"
                        id="phaseNote"
                        className="h-8 block text-xs w-full px-2 py-2 resize-y border-t border-stone-400 disabled:bg-white rounded-b-lg"
                        placeholder={'Phase Note..'}
                        value={phase.note}
                        disabled={true}
                    />
                )
            }

            break

        // Error Message
        default:
            console.error(mode + ' is not a valid mode!!')
    }
}
